module.exports = __webpack_public_path__ + "static/img/GettyImages-726798417.d27c1d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-726798417.jpg
// module id = YY71
// module chunks = 0